<template>
  <v-app-bar
    app
    dark
    class="header-container">
    <div v-if="is_logged" class="header">

      <div class="left-buttons" >
          <v-img
          :src="logo"
          class="logo"
          ></v-img>
          <div
          class="d-flex align-center header-title">
            НИЦ «Курчатовский институт»
          </div>

      </div>


      <div class="right-buttons">
        <div>
        </div>
        <div class="my-2">
          <v-skeleton-loader
            height="50"
            class="text-header">
            {{GETTERS_NAME_USER.length !== 0 ? GETTERS_NAME_USER : 'Без имени'}}
          </v-skeleton-loader>
        </div>
        <v-menu
          bottom
          left>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              color="#fff"
              v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-if="is_moderator"
              class="item-menu-text"
              small
              @click="goToPage('dashboard')">
               <v-list-item-action>
                <v-icon :color="$mainColor" >mdi-text-box-outline</v-icon>
              </v-list-item-action>
              <v-list-item-title>Статистика</v-list-item-title>
            </v-list-item>

            <v-list-item
              v-if="is_moderator"
              class="item-menu-text"
              small
              @click="goToPage('users-list')">
               <v-list-item-action>
                <v-icon :color="$mainColor" >mdi-text-box-outline</v-icon>
              </v-list-item-action>
              <v-list-item-title>Участники</v-list-item-title>
            </v-list-item>

            <v-list-item
              class="item-menu-text"
              small
              @click="goToPage('personal-data')">
               <v-list-item-action>
                <v-icon :color="$mainColor" >mdi-account-box</v-icon>
              </v-list-item-action>
              <v-list-item-title>Личный кабинет</v-list-item-title>
            </v-list-item>
          
            <v-list-item
              class="item-menu-text"
              v-if="GETTERS_HAVE_ROLE('moderator')"
              x-small
              @click="goToPage('users')">
              <v-list-item-action>
                <v-icon :color="$mainColor" >mdi-account-group</v-icon>
              </v-list-item-action>
              <v-list-item-title>Редактирование</v-list-item-title>
            </v-list-item>

            <v-list-item
              class="item-menu-text"
              small
              @click="goToPage('privacy')">
               <v-list-item-action>
                <v-icon :color="$mainColor" >mdi-text-box-outline</v-icon>
              </v-list-item-action>
              <v-list-item-title>Политика конфиденциальности</v-list-item-title>
            </v-list-item>

            <v-list-item
              class="item-menu-text"
              small
              @click="goToPage('logout')">
               <v-list-item-action>
                <v-icon :color="$mainColor" >mdi-logout</v-icon>
              </v-list-item-action>
              <v-list-item-title>Выйти</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
    <div class="header" v-else>
      <div class="left-buttons">
        <v-img
          :src="logo"
          class="logo"
        ></v-img>
        <div class="d-flex align-center header-title">
          НИЦ «Курчатовский институт»
        </div>
      </div>
      <div
       v-if="$route.name !== 'Login'"
       class="right-buttons">
          <v-btn depressed small :color="$mainColor"
           @click="login">Вход</v-btn>
      </div>
    </div>
    <v-spacer></v-spacer>


  </v-app-bar>
</template>

<script>
import logo from '../../assets/ustoc.png';
import { mapActions, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'Header',
  components: {
  },
  data() {
    return {
      logo,
      loading: true,
      is_logged: false,
      is_moderator: false,
    }
  },

  watch: {
    GETTERS_ISLOGGED(val){
      // console.log('!!!isLoggedIn change!!!', val)
      this.is_logged = this.GETTERS_ISLOGGED
      this.is_logged = val
    },

    GETTERS_CURRENT_USER(val) {
      this.set_permissions()
    },

  },

  mounted() {
    this.set_permissions()
    this.UPDATE_OVERLAY(false)
  },

  methods: {
    ...mapActions(['LOGOUT']),
    ...mapMutations([
      'SET_IS_LOGGED_IN', 
      'UPDATE_OVERLAY',
    ]),
    login() {
      this.$router.push('login');
    },

    set_permissions(){
      if (this.GETTERS_CURRENT_USER !== null) {
        this.is_logged = true
        try {
          for (var index = 0; index < this.GETTERS_CURRENT_USER.role.length; index++) {
            const element = this.GETTERS_CURRENT_USER.role[index];

            if (element.access_rights == 'moderator' || element.access_rights == 'conf_admin') {
              this.is_moderator = true;
            }
          }  
        } catch (ex) {
          console.log('ex ---> ', ex);
        }
      }
    },


    async goToPage(item, id) {
      switch (item) {
        case 'dashboard':
          this.$router.push('/dashboard');
          break;
        case 'users-list':
          this.$router.push('/users-list');
          break;
        case 'privacy':
          this.$router.push('/privacy');
          break;
        case 'users':
          this.$router.push('/users');
          break;
        case 'logout':
          this.SET_IS_LOGGED_IN('');
          this.LOGOUT()
          break;
        case 'personal-data':
          this.$router.push('/');
          break;

        default:
          break;
      }
    },
  },
  computed: {
    ...mapGetters([
      'GETTERS_NAME_USER',
      'GETTERS_ISLOGGED',
      'GETTERS_CURRENT_USER',
      'GETTERS_HAVE_ROLE',
    ]),
    isLoggedIn() {
      return localStorage.isLoggedIn;
    },
  },
};
</script>
<style lang="scss">
  @import '../../pages/css/trello_board.scss';
  .ui-container {
    margin-top: 100px;
  }
</style>
<style>
  @import '../../pages/css/statusUser.css';

  .header-container{
    -webkit-box-shadow: 0 .46875rem 2.1875rem rgba(4,9,20,.03),0 .9375rem 1.40625rem rgba(4,9,20,.03),0 .25rem .53125rem rgba(4,9,20,.05),0 .125rem .1875rem rgba(4,9,20,.03) !important;
    box-shadow: 0 .46875rem 2.1875rem rgba(4,9,20,.03),0 .9375rem 1.40625rem rgba(4,9,20,.03),0 .25rem .53125rem rgba(4,9,20,.05),0 .125rem .1875rem rgba(4,9,20,.03) !important;
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
  }
  body{
    background: hsla(0,0%,100%,.45)
  }
  .right-buttons{
    margin-top: 0px;
  }
  a:visited {
    color: white;
    text-decoration: none;
  }
  .icon{
    border-radius: 50%;
    margin-right: 7px;
  }
  .header-container .logo{
    height: 25px;
    width: 20px !important;
    flex: none !important;
  }
  a {
    text-decoration: none;
  }
.header-title{
  margin-left: 10px;
  width: 100%;
}
  .left-buttons {
    display: flex;
    flex-direction: row;
    width: 450px;
    align-content: center;
    align-items: center;
    justify-content: flex-start;
  }
  .text-header{
    font-size: 0.8125rem;
  }
  #select.menu {
    outline: none;
    border: 2px solid #FFFFFF;
    box-sizing: border-box;
    border-radius: 10px;
    padding: 0 5px;
    margin-right: 10px;
  }
  #select-auth.menu {
    outline: none;
    border: 2px solid #FFFFFF;
    box-sizing: border-box;
    border-radius: 10px;
    padding: 0 5px;
    margin-right: 10px;
  }
.hidden{
  display: none;
}
.switch-moderator{
  min-width: 350px;
  margin-top: 23px;
}
.cc_btn{
  margin-top: 10px;
}
  .header {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    padding: 0;
    height: 48px;
  }
  .header .left-buttons {
    height: 100%;
  }

  .right-buttons {
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
  }
 .v-btn.v-btn--contained.theme--dark.v-size--default{
    border-color: white;
  }/*
  .v-sheet.v-sheet--tile.theme--dark.v-toolbar.v-app-bar.v-app-bar--fixed{
    height: 43px!important;
  }
  .v-toolbar__content.v-toolbar__extension{
    height: 43px!important;
  }*/
  .header-container {
    z-index: 99999;
    height: 48px !important;
    min-height: 48px;
    background-color: #185ba6!important;
    -webkit-box-shadow: 0 .46875rem 2.1875rem rgba(4,9,20,.03),0 .9375rem 1.40625rem rgba(4,9,20,.03),0 .25rem .53125rem rgba(4,9,20,.05),0 .125rem .1875rem rgba(4,9,20,.03) !important;
    box-shadow: 0 .46875rem 2.1875rem rgba(4,9,20,.03),0 .9375rem 1.40625rem rgba(4,9,20,.03),0 .25rem .53125rem rgba(4,9,20,.05),0 .125rem .1875rem rgba(4,9,20,.03) !important;
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
  }
  .header-container .v-toolbar__content {
    height: 100% !important;
  }
  .btn-group-header{
    margin-left: 7px;
    outline: none;
  }
  .v-list-item__title {
    font-size: 13px;
    line-height: 15px;
  }

  @media screen and (max-width:660px) {
    .header {
      height: 100% !important;

    }
    .header-container {
      height: auto !important;
    }
  }
</style>
